import { BASE_HANDLER_URL } from ".";
import { DisplayMsg } from "../services/toastService";

export const GetAssigneesData = async () => {
  try {
    const queryParams = `&userType=${sessionStorage.type}&CP=${sessionStorage.CP}&APPUSER=${sessionStorage.USER}&Reseller=${sessionStorage.Reseller}`;
    const url = `${BASE_HANDLER_URL}?class=NOTES&action=LOADASSIGNEDDL&${queryParams}`;
    const result = await fetch(url, {
      method: "GET",
    });

    const response = await result.json();
    // hideLoader();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } 
      return response;
    
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};

export const GetClientCustomers = async () => {
  try {
    const queryParams = `&userType=${sessionStorage.type}&CP=${sessionStorage.CP}&APPUSER=${sessionStorage.USER}&Reseller=${sessionStorage.Reseller}`;
    const url = `${BASE_HANDLER_URL}?class=DASHBOARD&action=CLIENTS&${queryParams}`;
    const result = await fetch(url, {
      method: "GET",
    });

    const response = await result.json();
    if (response && response.data) {
      document.getElementById("loader").style.display = "none";
      return response;
    }
  } catch (e) {
    DisplayMsg("2", "Unable to Process the Request");
  }
  document.getElementById("loader").style.display = "none";
};
